import url from "./url";
const AppConsts = {
  userManagement: {
    defaultAdminUserName: "admin"
  },
  localization: {
    defaultLocalizationSourceName: "GoatBio"
  },
  authorization: {
    encrptedAuthTokenName: "enc_auth_token"
  },
  version: "V1.0.1",
  environment: process.env.NODE_ENV === "production" ? "PROD" : "TEST",
  lastUpdate: "12/30/2020",
  appBaseUrl: process.env.NODE_ENV === "production" ? "https://admin.goatsuccess.com" : process.env.NODE_ENV === "test" ? "https://testadmin.goatsuccess.com" : "http://localhost:8081",
  remoteServiceBaseUrl: url
};
export default AppConsts;
